export default "__VITE_ASSET__372032fa__"